// MODIFIED: Updated class names and spacing to match original UI
import React from "react";
import SalaryAdvanceModule from "../components/modules/SalaryAdvance/SalaryAdvanceModule";

function SalaryAdvancePage({ user, userAccess, isHideSideMenu }) {
  return (
    <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
      <div className="LeftSpace" />
      <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
        <div className="EmployeesTabInfo TransactionInfo">
          <div className="employeesTab-header transaction-header">
            <div className="sub-title row">
              <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>
                Loans & Benefits &gt;{" "}
              </span>
              <span style={{ borderBottom: "1px solid black" }}>Salary Advance</span>
            </div>
            <h3>Salary Advance</h3>
          </div>
          
          <SalaryAdvanceModule user={user} userAccess={userAccess} />
        </div>
      </div>
    </div>
  );
}

export default SalaryAdvancePage;